var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TermCheckbox_1;
import { Checkbox, Link } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import './term-checkbox.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import TermCheckApi from './term-checkbox-api';
import { getLostProps, isMobile, propagateProps, isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
let TermCheckbox = TermCheckbox_1 = class TermCheckbox extends Component {
    constructor() {
        super(...arguments);
        this.onClickTermo = () => {
            const { onClickTermo } = this.props;
            if (isFunction(onClickTermo)) {
                onClickTermo(new ClickEvent({
                    value: {
                        onClickTermo
                    }
                }));
            }
        };
        this.onClickAviso = () => {
            const { onClickAviso } = this.props;
            if (isFunction(onClickAviso)) {
                onClickAviso(new ClickEvent({
                    value: {
                        onClickAviso
                    }
                }));
            }
        };
    }
    getCheckbox() {
        const { value } = this.props;
        const lostProps = getLostProps(TermCheckbox_1, this.props);
        return propagateProps(React.createElement(Checkbox, { name: '', uuid: 'a31dafbf-8f63-4529-be1b-07ee2503fd94', label: ' ', value: value }), { ...this.props, ...lostProps });
    }
    getTermLink() {
        if (isMobile()) {
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("span", null, MessageService.translate('newaccount.text.agree.with')),
                    React.createElement("br", null)),
                React.createElement("div", null,
                    React.createElement("br", null),
                    React.createElement(Link, { className: 'c-mandatory_term', value: 'newaccount.link.terms', onClick: () => this.onClickTermo() }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                "\u00A0",
                MessageService.translate('newaccount.text.agree.with'),
                "\u00A0"),
            React.createElement(Link, { className: 'c-mandatory_term', value: 'newaccount.link.terms', onClick: () => this.onClickTermo() })));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-term-checkbox__wrapper' },
                React.createElement("div", { className: 'c-term-checkbox__checkbox' }, this.getCheckbox()),
                React.createElement("div", { className: 'c-term-checkbox__link' }, this.getTermLink())),
            React.createElement("br", null),
            React.createElement("div", { className: 'c-privacy__link' },
                React.createElement(Link, { value: 'newaccount.link.privacy', onClick: () => this.onClickAviso() }))));
    }
};
TermCheckbox.propTypes = {
    enabled: bool,
    onClickAviso: eventListener,
    onClickTermo: eventListener,
    value: bool
};
TermCheckbox = TermCheckbox_1 = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: TermCheckApi })
], TermCheckbox);
export default TermCheckbox;
//# sourceMappingURL=term-checkbox.js.map